<template>
    <v-row>
        <UnityEnvironmentConfig/>
        <UnityTemplatePackConfig/>
        <UnityEconomyConfig/>
    </v-row>
</template>

<script>
    import UnityEnvironmentConfig from '../modules/UnityEnvironmentConfig';
    import UnityEconomyConfig from '../modules/UnityEconomyConfig';
    import UnityTemplatePackConfig from '../modules/UnityTemplatePackConfig';

    export default {
        name: "UnityServiceDashboardForPopup",
        components: {
            UnityEnvironmentConfig,
            UnityEconomyConfig,
            UnityTemplatePackConfig
        }
    }
</script>

<style scoped>

</style>